// @ts-ignore
import { SUBJECTS_SLUGS } from '@yandex-int/k-common/constants';
import b from 'b_';
import cx from 'classnames';
import { PlusKit as IconPlusKit } from 'education-icons';
import hoistNonReactStatics from 'hoist-non-react-statics';
import { Button, SimpleText, SimpleCallback } from 'platform-components';
import { BUTTON_VIEW } from 'platform-components/src/components/button/types';
import { withRouterPath, InjectedProps as WithRouterPathProps } from 'platform-components/hocs';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import ym from 'react-yandex-metrika';
import { bindActionCreators, Dispatch } from 'redux';

import { actions as lessonActions } from 'common.components/lesson';
import * as userSelectors from 'common.components/user/selectors';

import { RootAction, ReduxTeacherStore } from '../../../typings';

import './course-view__add-lesson-button.scss';

interface HOCProps extends WithRouterPathProps {}

interface StoreProps {
    isCurrentClassNumberAvailable: boolean;
}

interface DispatchProps {
    clearEditor: typeof lessonActions.clearEditor;
}

interface OwnProps {
    mix?: string;
    sendMetrikaByCreateLesson?: SimpleCallback;
    view?: BUTTON_VIEW;
    textId?: string;
    subject?: string;
    classId?: string;
}

interface Props extends HOCProps, StoreProps, DispatchProps, OwnProps {}

class AddLessonButtonComponent extends React.Component<Props> {
    static contextTypes = {
        staticUrls: PropTypes.object.isRequired,
    };
    context!: React.ContextType<React.Context<{ staticUrls: Record<string, string> }>>;

    addLesson = () => {
        const {
            history: {
                location: { search },
            },
            clearEditor,
            getRouterPath,
            history,
            sendMetrikaByCreateLesson,
        } = this.props;
        const {
            staticUrls: { labLibrarySubject },
        } = this.context;

        const subject = this.props.subject ?? this.props.match.params.subject;
        const classId = this.props.classId ?? this.props.match.params.classId;
        clearEditor();
        const librarySubjectPath = getRouterPath(labLibrarySubject, { subject, classId });
        history.push(librarySubjectPath + search); // для мэша нужен query
        ym('reachGoal', 'click_create_lesson_in_list');
        if (sendMetrikaByCreateLesson) {
            sendMetrikaByCreateLesson();
        }
    };

    render() {
        const { mix, isCurrentClassNumberAvailable, view } = this.props;
        const subject = this.props.subject ?? this.props.match.params.subject;
        const canCreateLessonWithCards = subject !== SUBJECTS_SLUGS.custom;

        if (!isCurrentClassNumberAvailable || !canCreateLessonWithCards) {
            return null;
        }

        const textId = this.props.textId || 'educationHeaderWrapper.createLesson';

        return (
            <>
                <Button
                    className={cx(b('course-view', 'add-lesson-button', { desktop: true }), mix)}
                    icon={<IconPlusKit />}
                    onClick={this.addLesson}
                    view={view}
                >
                    <SimpleText id={textId} />
                </Button>
                <Button
                    className={cx(b('course-view', 'add-lesson-button', { mobile: true }), mix)}
                    icon={<IconPlusKit />}
                    onClick={this.addLesson}
                    size={Button.SIZE.L}
                    view={view}
                >
                    <SimpleText id={textId} />
                </Button>
            </>
        );
    }
}

const mapStateToProps = (storeState: ReduxTeacherStore, ownProps: HOCProps) => {
    const {
        match: { params },
    } = ownProps;
    const { classId: classIdFromMatch } = params || {};
    const classId = Number(classIdFromMatch);

    return {
        isCurrentClassNumberAvailable: userSelectors.getIsCurrentClassNumberAvailable(storeState, { classId }),
    };
};

const mapDispatchToProps = (dispatch: Dispatch<RootAction>): DispatchProps => {
    return bindActionCreators(
        {
            clearEditor: lessonActions.clearEditor,
        },
        dispatch
    );
};

const wrapped = withRouterPath(connect(mapStateToProps, mapDispatchToProps)(AddLessonButtonComponent));

export default hoistNonReactStatics(wrapped, AddLessonButtonComponent);
